export default {"src":"/_next/static/media/cross-icon.8137dd3c.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};